<div mat-dialog-title class="display-flex flex-column">
  <eon-ui-icon class="display-flex justify-end closeX" [mat-dialog-close]="{status: 'closed'}" name="close"></eon-ui-icon>
  <div class="headline">{{'confirmation-dialog.headline' | translate}}</div>
</div>

<ng-container>
  <mat-dialog-content class="dialog-content">
    <div>
      <div class="display-flex flex-column">
        <p class=" display-flex justify-center align-center">{{dialogText}}</p>
      </div>
    </div>
  </mat-dialog-content>

  <br/> <br/>
  <mat-dialog-actions class="justify-space-betwen">


    <eon-ui-button scheme="redInverted" icon="close" text="{{'general.cancel' | translate}}"
                   mat-dialog-close></eon-ui-button>
    <eon-ui-button text="OK" mat-dialog-close></eon-ui-button>
  </mat-dialog-actions>
</ng-container>
